import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Estudo } from './estudo';
import { MatSnackBar } from '@angular/material';

@Component({
  templateUrl: './instrucoes-detail.component.html',
	selector: 'instrucoes-detail',
})
export class InstrucoesDetailComponent implements OnInit {
    @Input() estudo : Estudo;
    @Output() proximoEmitido: EventEmitter<number> = new EventEmitter<number>();
    public isLoading: boolean;

    constructor(
      private mensagem: MatSnackBar)  {
    }

    ngOnInit() {
      if(this.estudo){
        this.isLoading = false;
      }
    }
  // mostra erros na tela
   erro(erro: string){
       this.mensagem.open(erro, 'X', {duration: 5000});
       this.isLoading= false;
   }


   proximo(){
     this.proximoEmitido.emit(1);
   }

}
